import React, { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  selectTypeAnnouncement,
  selectProfession,
  selectSelectedCityNum,
  selectAddress,
  selectCity,
  selectPhone,
  selectComment,
  selectCities,
  setTypeAnnouncement,
  setProfession,
  setSelectedCityNum,
  setAddress,
  setCity,
  setPhone,
  setComment,
  setAnnouncements,
  selectAnnouncementId,
} from './jobSlice';
import { selectUserId } from '../Login/loginSlice';
import { createAnnouncement, deleteAnnouncement, getAnnouncements, saveAnnouncement } from './jobApi';
import './job.css';

const NewAnnouncement = ({ onClose, isNewAnnouncement = true, setIsNewAnnouncement }) => {
  const dispatch = useDispatch();

  const typeAnnouncement = useSelector(selectTypeAnnouncement);
  const profession = useSelector(selectProfession);
  const selectedCityNum = useSelector(selectSelectedCityNum);
  const address = useSelector(selectAddress);
  const city = useSelector(selectCity);
  const phone = useSelector(selectPhone);
  const comment = useSelector(selectComment);
  const cities = useSelector(selectCities);
  const user_id = useSelector(selectUserId);
  const announcement_id = useSelector(selectAnnouncementId);

  const cityOptions = useMemo(() => cities || [], [cities]);

  const handleCreate = () => {
    const cleanedComment = (comment || '')
      .split('\n')
      .filter((l) => l.trim() !== '')
      .join('\n');
    createAnnouncement({
      type: typeAnnouncement,
      profession_id: profession === 'd' ? 2 : 3,
      city_id: cityOptions[selectedCityNum]?.id,
      city,
      address,
      phone,
      comment: cleanedComment,
      user_id,
    }, () => {
      getAnnouncements({ filters: [] }, (data) => {
        dispatch(setAnnouncements(data.announcements));
        dispatch(setCity(''));
        dispatch(setPhone(''));
        dispatch(setComment(''));
      });
      onClose?.();
    });
  };

  const handleSave = () => {
    saveAnnouncement({
      announcement_id,
      type: typeAnnouncement,
      profession_id: profession === 'd' ? 2 : 3,
      city_id: cityOptions[selectedCityNum]?.id,
      address,
      phone,
      comment,
      user_id,
    }, () => {
      getAnnouncements({ filters: 'my', user_id }, (data) => {
        dispatch(setAnnouncements(data.announcements));
      });
      onClose?.();
    });
  };

  const handleDelete = () => {
    deleteAnnouncement({ announcement_id }, () => {
      getAnnouncements({ filters: 'my', user_id }, (data) => {
        dispatch(setAnnouncements(data.announcements));
      });
      onClose?.();
    });
  };

  return (
    <div className="job-modal-overlay" onClick={onClose}>
      <div className="job-modal" onClick={(e) => e.stopPropagation()}>
        <div className="job-modal-header">
          <button className="job-close" onClick={onClose}>✕</button>
        </div>

        <div className="job-toggle-row">
          <button
            className={typeAnnouncement === 'r' ? 'btn-toggle active' : 'btn-toggle'}
            onClick={() => dispatch(setTypeAnnouncement('r'))}
          >
            Ищу работу
          </button>
          <button
            className={typeAnnouncement === 'v' ? 'btn-toggle active' : 'btn-toggle'}
            onClick={() => dispatch(setTypeAnnouncement('v'))}
          >
            Ищу сотрудника
          </button>
        </div>

        <div className="job-form-grid">
          <div className="form-field">
            <label className="label">Город</label>
            <input
              className="input"
              value={city || ''}
              onChange={(e) => {
                const t = e.target.value;
                const formatted = t.charAt(0).toUpperCase() + t.slice(1);
                dispatch(setCity(formatted));
              }}
              placeholder="Введите город.."
            />
          </div>

          <div className="form-field">
            <label className="label">Телефон</label>
            <input
              className="input"
              value={phone || ''}
              onChange={(e) => dispatch(setPhone(e.target.value))}
              placeholder="89090000000"
            />
          </div>

          <div className="form-field full">
            <label className="label">Комментарий</label>
            <textarea
              className="input"
              style={{ maxHeight: 80 }}
              value={comment || ''}
              onChange={(e) => dispatch(setComment(e.target.value))}
              placeholder="Укажите дополнительную информацию..."
              maxLength={70}
              rows={3}
            />
            <div className="hint">{(comment || '').length}/70</div>
          </div>
        </div>

        {isNewAnnouncement ? (
          <div className="job-actions">
            <button className="btn-primary" onClick={handleCreate}>Разместить</button>
          </div>
        ) : (
          <div className="job-actions">
            <button className="btn-primary" onClick={handleSave}>Сохранить</button>
            <button className="btn-outline" onClick={handleDelete}>Удалить</button>
          </div>
        )}
      </div>
    </div>
  );
};

export default NewAnnouncement;


